import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "../../components/AppProvider";
import { userHabit } from "../../modules/utils/UserHabit";
import { closeLayerFn, openLayerFn } from "../Layout";
import { ExeCycle } from "./ExeCycle";
import { ExeCycleLayer } from "./ExeCycle/ExeCycleLayer";
import { ExeIntensity } from "./ExeIntensity";
import { ExeSort } from "./ExeSort";


export const SetExerciseTarget = (props) => {

    const {excsInfo, setExType} = props;
    const {phonecfg} = useContext(AppContext);
    const [exeIdx, setExeIdx] = useState(0);

    const settingExeIdx = (idx, code) => {
        setExeIdx(idx);
        setExType(code);
    }

    useEffect(() => {
        $(".open-traning-set").click(function () {
            openLayerFn($(".traning-target-set"));
            userHabit(phonecfg, 'EX100_P02');
        });
        //닫기
        $(".traning-target-set .first .tbns-area a").click(function () {
            closeLayerFn($(".traning-target-set"));
        });
    }, []);

    return (
        // <div className="blacklayer-container traning-today-set">
        <div className="blacklayer-container traning-target-set">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div className="blgrn-box vertical intwobox">
                    <div className="first">
                        <div className="blgr-title">목표 운동 설정</div>

                        <div className="inly-sutit-list">
                            <ExeSort excsInfo={excsInfo} settingExeIdx={settingExeIdx} />
                            <ExeIntensity excsInfo={excsInfo} exeIdx={exeIdx} />

                            <ExeCycle />
                        </div>

                        <div className="tbns-area">
                            <a className="btn-round gray">취소</a>
                            <a className="btn-round wht">확인</a>
                        </div>

                    </div>

                    {/* 운동주기설정 */}
                    <ExeCycleLayer mode="TIME" />
                </div>
            </div>
        </div>
    );
};